{
  "AI": "AI",
  "AI-Requested via phone call": "AI-Requested via phone call",
  "AI-Requested via text message": "AI-Requested via text message",
  "Additional Data": "Additional Data",
  "Any": "Any",
  "Anytime": "Anytime",
  "Appointment Preferences": "Appointment Preferences",
  "Appointment request completed successfully": "Appointment request completed successfully",
  "Appointment request deleted successfully": "Appointment request deleted successfully",
  "Appointment request dismissed successfully": "Appointment request dismissed successfully",
  "Appointment request rejected successfully": "Appointment request rejected successfully",
  "Are you sure you want to delete this request?": "Are you sure you want to delete this request?",
  "Are you sure you want to dismiss this request?": "Are you sure you want to dismiss this request?",
  "Are you sure you want to reject this request?": "Are you sure you want to reject this request?",
  "Attribution": "Attribution",
  "Availability Preferences": "Availability Preferences",
  "Birthdate": "Birthdate",
  "Call": "Call",
  "Campaign": "Campaign",
  "Carrier": "Carrier",
  "Comments": "Comments",
  "Confirm": "Confirm",
  "Contact information": "Contact information",
  "Contacted on {{lastContactedOn}}": "Contacted on {{lastContactedOn}}",
  "Date of Birth": "Date of Birth",
  "Delete": "Delete",
  "Dismiss": "Dismiss",
  "Done": "Done",
  "Early Morning": "Early Morning",
  "Email": "Email",
  "Error fetching request details.": "Error fetching request details.",
  "Existing": "Existing",
  "Failed to complete appointment request": "Failed to complete appointment request",
  "Failed to delete appointment request": "Failed to delete appointment request",
  "Failed to dismiss appointment request": "Failed to dismiss appointment request",
  "Failed to make phone call to patient": "Failed to make phone call to patient",
  "Failed to reject appointment request": "Failed to reject appointment request",
  "Failed to send message to patient": "Failed to send message to patient",
  "Fri": "Fri",
  "Google Business Profile": "Google Business Profile",
  "Group Number": "Group Number",
  "Instagram": "Instagram",
  "Insurance": "Insurance",
  "Last Contacted on {{datetime}}": "Last Contacted on {{datetime}}",
  "Late": "Late",
  "Message": "Message",
  "Midday": "Midday",
  "Mon": "Mon",
  "New": "New",
  "Partner": "Partner",
  "Patient": "Patient",
  "Patient Type": "Patient Type",
  "Phone": "Phone",
  "Platform": "Platform",
  "Preferred Contact": "Preferred Contact",
  "Preferred Days": "Preferred Days",
  "Preferred Time": "Preferred Time",
  "Reason for Visit": "Reason for Visit",
  "Reject Request": "Reject Request",
  "Request": "Request",
  "Request Data": "Request Data",
  "Requested on {{requestTime}}": "Requested on {{requestTime}}",
  "Review Request": "Review Request",
  "SMS": "SMS",
  "Sat": "Sat",
  "Source": "Source",
  "Subscriber ID": "Subscriber ID",
  "Subscriber Name": "Subscriber Name",
  "Sun": "Sun",
  "Text": "Text",
  "Thu": "Thu",
  "Tue": "Tue",
  "Urgent": "Urgent",
  "View Call Insights": "View Call Insights",
  "View Conversation": "View Conversation",
  "View Request": "View Request",
  "Voice": "Voice",
  "Web App": "Web App",
  "Website": "Website",
  "Wed": "Wed",
  "You do not have permission to send text messages": "You do not have permission to send text messages"
}
